<template>
  <div class="frm-row">
    <span class="frm-label w-140px" v-if="initItemName">{{
      initItemName
    }}</span>
    <select
      class="frm-select frm-size-l"
      v-model="itemData.selectItem"
      @change="handleSelectItemChange"
    >
      <option
        v-for="item in initSelectItemList"
        :key="item.code"
        :value="item.code"
      >
        {{ item.name }}
      </option>
    </select>
    <input
      title=" "
      :type="textType"
      class="frm-text frm-size-xxml"
      :maxlength="maxLength"
      v-model.trim="itemData.inputItem"
      v-if="isShowInputItem"
      @input="inputValue"
      :disabled="isInputItemDisabled"
      :class="{ error: itemData.isError }"
    />
  </div>
</template>

<script>
import Validation from "@/util/validation.js";

export default {
  name: "STDSDC01C09SelectChangeForm",
  data() {
    return {
      itemData: {
        selectItem: 0,
        inputItem: "",
        isError: false,
        isItemChange: false,
        errorMsg: "",
      },
    };
  },
  mounted() {
    //this.initDataSetting();
  },
  props: {
    // 表示制御　入力項目
    isShowInputItem: {
      type: Boolean,
      default: true,
    },
    // 項目名
    initItemName: {
      type: String,
      default: "",
    },
    // 初期値 選択した値
    initSelectItem: {
      type: Number,
      default: 0,
    },
    // 初期値 ドロップダウンリスト
    initSelectItemList: {
      type: Array,
      default: () => [{ code: 0, name: "選択してください。" }],
    },
    // 初期値 入力項目
    initInputItem: {
      type: String,
      default: "",
    },
    initMsgCode: {
      type: String,
      default: "MTCL1001",
    },
    initUnCheckPattern: {
      type: Array,
      default: () => [],
    },
    //入力項目　表示桁数
    maxLength: {
      type: String,
      default: "255",
    },
    //入力項目　表示種類（半角数字・全角）
    textType: {
      type: String,
      default: "text",
    },
  },
  methods: {
    // **********************************************
    // ドロップダウン項目変更
    // **********************************************
    handleSelectItemChange(e) {
      this.itemData.selectItem = e.target.value;
      if (
        this.itemData.selectItem == this.initSelectItemList[0].code ||
        this.itemData.selectItem == 100
      ) {
        this.itemData.inputItem = "";
      }
      this.$emit("update:initSelectItem", this.itemData.selectItem);
      this.$emit("update:initInputItem", this.itemData.inputItem);
    },
    // **********************************************
    // 各項目クリア
    // **********************************************
    clearAll() {
      // 初期化
      this.itemData = {
        selectItem: 0,
        inputItem: "",
        isError: false,
        isItemChange: false,
        errorMsg: "",
      };
      this.initDataSetting();
    },
    // **********************************************
    // エラー項目クリア
    // **********************************************
    clearError() {
      // 初期化
      this.itemData.isError = false;
      this.itemData.errorMsg = "";
    },
    // **********************************************
    // 次へ押下時のチェック
    // **********************************************
    handleCheckAll() {
      this.itemData.errorMsg = "";
      this.itemData.isError = false;
      this.itemData.isItemChange = false;
      let isUnCheck =
        this.initUnCheckPattern.filter(
          (el) => el.code == this.itemData.selectItem
        ).length <= 0;
      // チェック
      if (this.isShowInputItem && isUnCheck) {
        // 入力項目(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.itemData.selectItem,
          this.itemData.inputItem,
          this.initItemName
        );
        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.itemData.errorMsg = msg;
          this.itemData.isError = true;
        }
      }
      // 項目変更チェック
      // if (
      //   this.itemData.selectItem != 0 &&
      //   (this.itemData.selectItem != this.initSelectItem ||
      //     this.itemData.inputItem != this.initInputItem)
      // ) {
      //   this.itemData.isItemChange = true;
      // }
      if (this.itemData.selectItem != 0) {
        this.itemData.isItemChange = true;
      }
      //this.$emit("checkResult", this.itemData);
      return this.itemData;
    },
    // **********************************************
    // 初期値設定
    // **********************************************
    initDataSetting() {
      this.selectItem = this.initSelectItem;
      this.inputItem = this.initInputItem;
    },
    inputValue(e) {
      const value = e.target.value;
      this.$emit("update:initInputItem", value);
    },
  },
  computed: {
    // **********************************************
    // テキストコントロールを非活性にする
    // **********************************************
    isInputItemDisabled() {
      return (
        this.itemData.selectItem == this.initSelectItemList[0]?.code ||
        this.itemData.selectItem == 100
      );
    },
  },
  watch: {
    initSelectItem: {
      handler: function (newVal, oldVal) {
        // if (newVal != oldVal) {
        this.itemData.selectItem = newVal;
        // }
      },
      immediate: true,
    },
    initInputItem: function (newVal, oldVal) {
      // if (newVal != oldVal) {
      this.itemData.inputItem = newVal;
      // }
    },
  },
};
</script>

<style scoped>
.frm-row.mt-20px {
  margin-top: 20px;
}
</style>